var map = {
	"./bg_alternate-login.svg": 1979,
	"./bg_home.svg": 6742,
	"./bg_login-mobile.svg": 3897,
	"./bg_login.svg": 2538,
	"./imersys.svg": 7493,
	"./logo_sagah.svg": 5445,
	"./v-chip.svg": 892
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5801;